import React from "react";
import { Container } from "@mui/material";
import { Box } from "../../../design-system";
import { colors } from "../../../design-system/colors";
import HeroBackground from "./HeroBackground";
import HeroContent from "./HeroContent";

interface HeroSectionProps {
  onCTAClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onCTAClick }) => {
  return (
    <Box
      component="section"
      aria-label="Hero section"
      sx={{
        position: "relative",
        minHeight: "788px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.background[850],
      }}
    >
      <HeroBackground />
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <HeroContent onCTAClick={onCTAClick} />
      </Container>
    </Box>
  );
};

export default HeroSection;
